(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/breed-search-banner"],{

/***/ "./src/assets/js/breed-search-banner.js":
/*!**********************************************!*\
  !*** ./src/assets/js/breed-search-banner.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var BreedSearchWidget = /*#__PURE__*/function (_HTMLElement) {
  function BreedSearchWidget() {
    var _this;
    _classCallCheck(this, BreedSearchWidget);
    _this = _callSuper(this, BreedSearchWidget);
    _this.searchInput = _this.querySelector('input');
    _this.submitButton = _this.querySelector('button');
    _this.dropdown = _this.querySelector('.breed-search-widget__wrapper-dropdown');
    _this.sectionId = _this.getAttribute('data-section-id');
    _this.breedsData = window['breedDataForSection' + _this.sectionId];
    _this.mixText = _this.getAttribute('data-mix-text');
    _this.mixUrl = _this.getAttribute('data-mix-url');
    _this.otherText = _this.getAttribute('data-other-text');
    _this.otherUrl = _this.getAttribute('data-other-url');
    _this.innerWidget = _this.querySelectorAll('.inner-widget');
    _this.wrapperWidget = _this.querySelector('.breed-search-widget__wrapper');
    _this.menuWidget = _this.querySelector('.breed-search-widget__menu');
    _this.formurl = _this.getAttribute('data-form-url');
    _this.textEntry = _this.getAttribute('data-text-entry');
    _this.slideshowPictures = document.querySelectorAll('.breed-search-banner__images picture');
    _this.breedSearchWidget = _this;
    _this.slideshowIndex = 0;
    _this.fuse = null;
    _this.useModel = null;
    _this.breedEmbeddings = null;
    _this.breedList = [];
    _this.selectedBreedUrl = null;
    _this.isDropdownOpen = false;
    _this.modelLoaded = false;
    _this.modelLoading = false;
    _this.isProcessing = false;
    _this.librariesLoaded = false;
    _this.slideshowInterval = null;
    _this.blurTimeout = null;
    return _this;
  }
  _inherits(BreedSearchWidget, _HTMLElement);
  return _createClass(BreedSearchWidget, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initDropdown();
      this.setupEventListeners();
      this.setupSlideshow();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Cleanup intervals
      if (this.slideshowInterval) {
        clearInterval(this.slideshowInterval);
        this.slideshowInterval = null;
      }
      // Cleanup timeouts
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }
    }
  }, {
    key: "setupEventListeners",
    value: function setupEventListeners() {
      var _this2 = this;
      this.searchInput.addEventListener('focus', function () {
        return _this2.openDropdown();
      });
      this.searchInput.addEventListener('blur', function () {
        if (_this2.blurTimeout) clearTimeout(_this2.blurTimeout);
        _this2.blurTimeout = setTimeout(function () {
          return _this2.closeDropdown();
        }, 200);
      });
      this.searchInput.addEventListener('input', this.debounce(this.onInputChange.bind(this), 300));
      this.searchInput.addEventListener('keydown', function (event) {
        return _this2.handleKeydown(event);
      });
      this.submitButton.addEventListener('click', function (e) {
        e.preventDefault();
        _this2.redirectToBreedUrl();
      });
      // Add touch support for iOS
      this.submitButton.addEventListener('touchend', function (e) {
        e.preventDefault();
        _this2.redirectToBreedUrl();
      });
    }
  }, {
    key: "openDropdown",
    value: function openDropdown() {
      if (this.isDropdownOpen) return;
      this.isDropdownOpen = true;
      this.dropdown.classList.add('active');
      this.innerWidget.forEach(function (el) {
        return el.classList.add('hidden');
      });
      this.wrapperWidget.classList.add('lower');
      this.breedSearchWidget.style.background = 'var(--global-bg)';
      this.breedSearchWidget.style.opacity = '1';
      this.menuWidget.classList.add('open');
      var banner = this.closest('.main-banner-id');
      if (banner) banner.style.border = 'none';
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.isDropdownOpen = false;
      this.dropdown.classList.remove('active');
      this.innerWidget.forEach(function (el) {
        return el.classList.remove('hidden');
      });
      this.wrapperWidget.classList.remove('lower');
      this.menuWidget.classList.remove('open');
      this.breedSearchWidget.style.background = 'transparent';
      var banner = this.closest('.main-banner-id');
      if (banner) banner.style.border = '2px solid var(--yellow-bg)';
    }
  }, {
    key: "setupSlideshow",
    value: function setupSlideshow() {
      var _this3 = this;
      if (this.slideshowPictures.length > 0) {
        this.slideshowPictures[0].classList.add('active');
        this.slideshowInterval = setInterval(function () {
          _this3.slideshowPictures[_this3.slideshowIndex].classList.remove('active');
          _this3.slideshowIndex = (_this3.slideshowIndex + 1) % _this3.slideshowPictures.length;
          _this3.slideshowPictures[_this3.slideshowIndex].classList.add('active');
        }, 850);
      }
    }
  }, {
    key: "debounce",
    value: function debounce(func, wait) {
      var _this4 = this;
      var timeout;
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          return func.apply(_this4, args);
        }, wait);
      };
    }
  }, {
    key: "loadLibraries",
    value: function () {
      var _loadLibraries = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.librariesLoaded) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              if (window.Fuse) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return this.loadScript('https://cdn.jsdelivr.net/npm/fuse.js@7.1.0/dist/fuse.min.js');
            case 2:
              this.librariesLoaded = true;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('Error loading libraries:', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function loadLibraries() {
        return _loadLibraries.apply(this, arguments);
      }
      return loadLibraries;
    }()
  }, {
    key: "loadScript",
    value: function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (document.querySelector("script[src=\"".concat(src, "\"]"))) {
          resolve();
          return;
        }
        var script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  }, {
    key: "initDropdown",
    value: function () {
      var _initDropdown = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.loadLibraries();
            case 1:
              this.breedList = _toConsumableArray(new Set(this.breedsData.flatMap(function (d) {
                return d.breedList;
              }))).sort(function (a, b) {
                return a.localeCompare(b);
              });
              if (window.Fuse) {
                this.fuse = new window.Fuse(this.breedList, {
                  includeScore: true,
                  threshold: 0.4
                });
              }
              this.renderDropdownItems(this.breedList);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function initDropdown() {
        return _initDropdown.apply(this, arguments);
      }
      return initDropdown;
    }()
  }, {
    key: "onInputChange",
    value: function () {
      var _onInputChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
        var raw, simpleResults, fuseResults, sorted, _simpleResults, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.isProcessing) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.selectedBreedUrl = null;
              raw = event.target.value.trim().toLowerCase();
              if (raw) {
                _context3.n = 2;
                break;
              }
              this.renderDropdownItems(this.breedList);
              this.hideNothingFound();
              return _context3.a(2);
            case 2:
              this.isProcessing = true;
              _context3.p = 3;
              simpleResults = this.breedList.filter(function (breed) {
                return breed.toLowerCase().includes(raw);
              }).sort(function (a, b) {
                var aStarts = a.toLowerCase().startsWith(raw);
                var bStarts = b.toLowerCase().startsWith(raw);
                if (aStarts && !bStarts) return -1;
                if (!aStarts && bStarts) return 1;
                return 0;
              }).slice(0, 10);
              if (!(simpleResults.length > 0)) {
                _context3.n = 4;
                break;
              }
              this.renderDropdownItems(simpleResults);
              this.hideNothingFound();
              this.isProcessing = false;
              return _context3.a(2);
            case 4:
              if (!this.fuse) {
                _context3.n = 5;
                break;
              }
              fuseResults = this.fuse.search(raw);
              if (!(fuseResults.length > 0)) {
                _context3.n = 5;
                break;
              }
              sorted = fuseResults.map(function (res) {
                return res.item;
              });
              this.renderDropdownItems(sorted);
              this.hideNothingFound();
              this.isProcessing = false;
              return _context3.a(2);
            case 5:
              this.renderDropdownItems([]);
              this.showNothingFound();
              _context3.n = 7;
              break;
            case 6:
              _context3.p = 6;
              _t2 = _context3.v;
              console.error('Search error:', _t2);
              _simpleResults = this.breedList.filter(function (breed) {
                return breed.toLowerCase().includes(raw);
              });
              this.renderDropdownItems(_simpleResults);
              if (_simpleResults.length === 0) {
                this.showNothingFound();
              } else {
                this.hideNothingFound();
              }
            case 7:
              _context3.p = 7;
              this.isProcessing = false;
              return _context3.f(7);
            case 8:
              return _context3.a(2);
          }
        }, _callee3, this, [[3, 6, 7, 8]]);
      }));
      function onInputChange(_x) {
        return _onInputChange.apply(this, arguments);
      }
      return onInputChange;
    }()
  }, {
    key: "loadTensorFlowIfNeeded",
    value: function () {
      var _loadTensorFlowIfNeeded = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(raw) {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(!this.modelLoaded && !this.modelLoading && raw.length > 3)) {
                _context4.n = 9;
                break;
              }
              this.modelLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return this.loadScript('https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@4.22.0/dist/tf.min.js');
            case 2:
              _context4.n = 3;
              return this.loadScript('https://cdn.jsdelivr.net/npm/@tensorflow-models/universal-sentence-encoder@1.3.3/dist/universal-sentence-encoder.min.js');
            case 3:
              if (!(window.tf && window.use)) {
                _context4.n = 6;
                break;
              }
              _context4.n = 4;
              return window.use.load();
            case 4:
              this.useModel = _context4.v;
              _context4.n = 5;
              return this.computeBreedEmbeddings();
            case 5:
              this.modelLoaded = true;
            case 6:
              _context4.n = 8;
              break;
            case 7:
              _context4.p = 7;
              _t3 = _context4.v;
              console.error('TensorFlow loading error:', _t3);
            case 8:
              _context4.p = 8;
              this.modelLoading = false;
              return _context4.f(8);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 7, 8, 9]]);
      }));
      function loadTensorFlowIfNeeded(_x2) {
        return _loadTensorFlowIfNeeded.apply(this, arguments);
      }
      return loadTensorFlowIfNeeded;
    }()
  }, {
    key: "computeBreedEmbeddings",
    value: function () {
      var _computeBreedEmbeddings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var embeddings, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!(!this.useModel || !this.breedList.length)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return this.useModel.embed(this.breedList);
            case 2:
              embeddings = _context5.v;
              this.breedEmbeddings = embeddings;
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              console.error('Breed embedding error:', _t4);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function computeBreedEmbeddings() {
        return _computeBreedEmbeddings.apply(this, arguments);
      }
      return computeBreedEmbeddings;
    }()
  }, {
    key: "renderDropdownItems",
    value: function renderDropdownItems(breeds) {
      var _this5 = this;
      var MAX_ITEMS = 20;
      var limited = breeds.slice(0, MAX_ITEMS);
      this.dropdown.innerHTML = limited.map(function (b) {
        return "<div class=\"dropdown-item\" data-breed=\"".concat(b, "\">").concat(b, "</div>");
      }).join('');
      this.dropdown.querySelectorAll('.dropdown-item').forEach(function (item) {
        // Add both mouse and touch event handlers for iOS compatibility
        item.addEventListener('click', _this5.selectBreed.bind(_this5));
        item.addEventListener('mousedown', function (e) {
          return e.preventDefault();
        });
        item.addEventListener('touchstart', function (e) {
          e.preventDefault();
          _this5.selectBreed(e);
        });
        item.addEventListener('touchend', function (e) {
          return e.preventDefault();
        });
      });
      this.dropdown.style.height = limited.length > 4 ? '180px' : 'auto';
    }
  }, {
    key: "selectBreed",
    value: function selectBreed(event) {
      event.preventDefault();
      event.stopPropagation();

      // Clear any pending blur timeout to prevent dropdown from closing prematurely
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }
      var breed = event.target.dataset.breed || event.currentTarget.dataset.breed;
      if (!breed) return;
      this.searchInput.value = breed;
      var breedData = this.breedsData.find(function (d) {
        return d.breedList.includes(breed);
      });
      if (breedData) {
        this.selectedBreedUrl = breedData.breedUrl;

        // Add visual feedback for iOS
        event.target.style.backgroundColor = 'var(--yellow-bg)';
        setTimeout(function () {
          event.target.style.backgroundColor = '';
        }, 150);
      }
      this.closeDropdown();
      this.searchInput.blur();
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.redirectToBreedUrl();
    }
  }, {
    key: "redirectToBreedUrl",
    value: function redirectToBreedUrl() {
      if (this.selectedBreedUrl) {
        this.submitInfoToGoogle(this.searchInput.value, this.selectedBreedUrl);
      } else {
        window.location.href = this.mixUrl || this.otherUrl || '/';
      }
    }
  }, {
    key: "submitInfoToGoogle",
    value: function submitInfoToGoogle(value, url) {
      if (this.formurl && this.textEntry) {
        var data = "".concat(encodeURIComponent(this.textEntry), "=").concat(encodeURIComponent(value));
        fetch(this.formurl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: data,
          mode: 'no-cors'
        })["finally"](function () {
          if (url) window.location.href = url;
        });
      } else if (url) {
        window.location.href = url;
      }
    }
  }, {
    key: "showNothingFound",
    value: function showNothingFound() {
      var _this6 = this;
      this.hideNothingFound();
      if (this.mixText) {
        var msg = document.createElement('div');
        msg.className = 'nothing-found';
        msg.textContent = this.mixText;
        msg.addEventListener('mousedown', function (e) {
          return e.preventDefault();
        });
        msg.addEventListener('click', function () {
          return window.location.href = _this6.mixUrl;
        });
        this.dropdown.appendChild(msg);
      }
      if (this.otherText) {
        var other = document.createElement('div');
        other.className = 'other-text-message';
        other.textContent = this.otherText;
        other.addEventListener('mousedown', function (e) {
          return e.preventDefault();
        });
        other.addEventListener('click', function () {
          return window.location.href = _this6.otherUrl;
        });
        this.dropdown.appendChild(other);
      }
    }
  }, {
    key: "hideNothingFound",
    value: function hideNothingFound() {
      this.dropdown.querySelectorAll('.nothing-found, .other-text-message').forEach(function (el) {
        return el.remove();
      });
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('breed-search-widget')) {
  customElements.define('breed-search-widget', BreedSearchWidget);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/breed-search-banner.js"));
/******/ }
]);